import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AccountingAllocationRelation  {
    _originalTypeClassName = "zERP.BO.AccountingAllocationRelation";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountingAllocationRelation.translate = translateService;
}
this.Entity = new Domain.AccountingBusinessEntity();
this.TargetJournal = new Domain.AccountingJournal();
this.Details = [];
this.Id = null;
this.Name = null;
this.Description = null;
this.IsEnabled = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Description:any;
IsEnabled:any;
Entity:any;
FiscalPeriod:any;
SourceLedger:any;
TargetLedger:any;
TargetJournal:any;
Details:any;
TAccount:any;
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setFiscalPeriod = ($this, value) => {
var oldValue = $this.FiscalPeriod;
$this.FiscalPeriod = value;
if (value != null) {
}
}
static setSourceLedger = ($this, value) => {
var oldValue = $this.SourceLedger;
$this.SourceLedger = value;
if (value != null) {
}
}
static setTargetLedger = ($this, value) => {
var oldValue = $this.TargetLedger;
$this.TargetLedger = value;
if (value != null) {
}
}
static setTargetJournal = ($this, value) => {
var oldValue = $this.TargetJournal;
$this.TargetJournal = value;
if (value != null) {
}
}
static setDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.Details == null) $this.Details = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Details.length > 0) {
                    Domain.AccountingAllocationRelation.removeDetails($this, $this.Details[0]);
                }

                Domain.AccountingAllocationRelation.addManyDetails($this, copyItems);
            }
static addManyDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AccountingAllocationRelation.addDetails($this, items[i]);
                }
            }
static addDetails = ($this, item) => {
                if ($this.Details == null) $this.Details = [];
                if (item == null || $this.Details.indexOf(item) > -1) return;
                $this.Details.push(item);
}
static addRangeDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AccountingAllocationRelation.addDetails($this, item));
            }
static removeDetails = ($this, item) => {
                if ($this == null || $this.Details == null || $this.Details.indexOf(item) === -1) return;
                var _index = $this.Details.indexOf(item);
                $this.Details.splice(_index, 1);
}
static clearDetails = ($this) => { $this.Details = null; }
static setTAccount = ($this, value) => {
var oldValue = $this.TAccount;
$this.TAccount = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}